import { EventModel } from "@bryntum/schedulerpro"

// Custom JobEventModel model, based on EventModel with changed defaults
// This class can be used to modify the default values of the EventModel
export class JobEventModel extends EventModel {
    static defaults = {
        durationUnit: "h",
    }
}
